import { gql } from '@apollo/client';

export const getDeviceQuery = gql`
  query GetDevice($input: GetDeviceInput!) {
    getDevice(input: $input) {
      ... on Terminal {
        typename: __typename
        id
        address
        approvalsCount
        location {
          lat
          lon
        }
        notes
        organization
        registrationDate
        status
        user {
          id
        }
      }
    }
  }
`;
